/**
 * Actycrea: toggle.esm.js (ES6)
 * MIT
 */

import { PREFIX } from '../helpers/config.js';

/* =========================
 * Constantes de configuración
 * =======================*/

const SELECTOR           = `data-${PREFIX}-mytg`;
const SELECTOR_DATA      = `[${SELECTOR}]`;
const SELECTOR_DATA_TRIGGER = `[data-${PREFIX}-toggle]`;
const DATA_KEY_TRIGGER   = `${PREFIX}Toggle`;

const DEFAULTS = {
  selector : false ,
};

/* =========================
 * Clase
 * =======================*/
export class MyTG {
  /**
   * @param {HTMLElement} element – contenedor raíz
   * @param {Object}       config  – mergea DEFAULTS + JSON + arg
   */
  constructor(element, config = {}) {
    if (!(element instanceof HTMLElement)) throw new Error('MyTG: element inválido');

    // merge: DEFAULTS ← arg
    this._config  = { ...DEFAULTS, ...config };

    console.log( this._config , config );

    this._element = element;

    this._onClick = this._onClick.bind(this);

    // Delegación: escucha un único click en el contenedor
    this._element.addEventListener('click', this._onClick, false);
  }

  /* ============
   * Handlers
   * ===========*/
  _onClick(evt) {
    const btn = evt.target.closest(SELECTOR_DATA_TRIGGER);
    if (!btn) return;
    const cls = btn.dataset[DATA_KEY_TRIGGER];
    if (!cls) return;

    evt.preventDefault();
    if( this._config.selector == false ){
      this._element.classList.toggle(cls);
    } else {
      let selector = document.querySelectorAll( this._config.selector );
      selector.forEach( (el) => {
        el.classList.toggle(cls);
      });
      console.log( this._config.selector , selector );
    }

  }

  static initAll(root = document) {
    const nodes = root.querySelectorAll(SELECTOR_DATA);
    const instances = [];
    nodes.forEach((el) => {
      if (el._mytgInstance) return;
      let cfg = {};
      const raw = el.getAttribute(SELECTOR);
      console.log( raw );
      if (raw) {
        try { cfg = JSON.parse(raw); } catch (_) { cfg = {}; }
      }
      el._mytgInstance = new MyTG(el, cfg);
      instances.push(el._mytgInstance);
    });
    return instances;
  }
}

export default MyTG;
